import { supabase } from '@/integrations/supabase/client';
import { normalizeExternalLinkPreview, type ExternalLinkPreview } from '../../shared/community';

const previewCache = new Map<string, ExternalLinkPreview | null>();
const pendingPreviewRequests = new Map<string, Promise<ExternalLinkPreview | null>>();

export const fetchExternalLinkPreview = (url: string) => {
  if (previewCache.has(url)) return Promise.resolve(previewCache.get(url) ?? null);
  const pending = pendingPreviewRequests.get(url);
  if (pending) return pending;

  const request = supabase.functions
    .invoke('fetch-link-preview', { body: { url } })
    .then(({ data, error }) => (error ? null : normalizeExternalLinkPreview(data, url)))
    .catch(() => null)
    .then((preview) => {
      previewCache.set(url, preview);
      pendingPreviewRequests.delete(url);
      return preview;
    });

  pendingPreviewRequests.set(url, request);
  return request;
};
